<template>
  <div class="countdown-container">
    <div v-if="!hasStarted" class="not-started-message">
      카운트다운이 곧 시작됩니다
    </div>
    <div v-else-if="isEnded" class="ended-message">
      종료되었습니다
    </div>
    <div v-else class="timer-container">
      <div class="time-block">
        <span class="number">{{ days }}</span>
      </div>
      <span class="label">일</span>
      <div class="time-block">
        <span class="number">{{ hours }}</span>
      </div>
      <span class="label">시간</span>
      <div class="time-block">
        <span class="number">{{ minutes }}</span>
      </div>
      <span class="label">분</span>
      <div class="time-block">
        <span class="number">{{ seconds }}</span>
      </div>
      <span class="label">초</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    }
  },
  
  data() {
    return {
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
      isEnded: null,
      hasStarted: false,
      timer: null
    }
  },

  methods: {
    updateRemaining(distance) {
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
    },

    tick() {
      const currentTime = new Date()
      
      // 시작 시간 체크
      if (currentTime < this.startDate) {
        this.hasStarted = false
        return
      }
      
      this.hasStarted = true
      const distance = Math.max(this.endDate - currentTime, 0)
      
      this.updateRemaining(distance)
      
      if (distance === 0) {
        clearInterval(this.timer)
        this.isEnded = true
      }
    }
  },

  mounted() {
    this.tick()
    this.timer = setInterval(this.tick.bind(this), 1000)
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.countdown-container {
  padding: 20px;
  text-align: center;
}

.timer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.time-block {
  background-color: #E5F0FC;
  border-radius: 10px;
  width: 97px;
  height: 91px;
  padding: 4px;
  margin-left: 5px;
}

.number {
  font-size: 59px;
  font-weight: 600;
  line-height: 84px;
  letter-spacing: -0.02em;
  color: #333;
  display: block;
}

.label {
  font-size: 59px;
  color: #fff;
  font-weight: 600;
  margin-top: 5px;
  display: block;
}

.ended-message {
  font-size: 42px;
  color: #333;
  font-weight: bold;
  background-color: #E5F0FC;
  border-radius: 10px;
  padding: 30px 0;
}

/* .not-started-message {
  font-size: 1.5rem;
  color: #007bff;
  font-weight: bold;
} */

 @media (max-width: 767.98px) {
   .label {
    font-size: 32px;
    letter-spacing: -0.03em;
    margin-top: 0;
   }
   .number {
    font-size: 32px;
    line-height: 47px;
   }
   .time-block {
    width: 50px;
    height: 47px;
    padding: 0;
    border-radius: 5px;;
   }
   .countdown-container {
    padding: 8px 14px 14px;
   }
 }

 @media (max-width: 408px) {
   .label {
    font-size: 26px;
    letter-spacing: -0.04em;
   }
   .number {
    font-size: 26px;
    line-height: 42px;
   }
   .time-block {
    width: 44px;
    height: 42px;
   }
 }
</style>


// WEBPACK FOOTER //
// src/components/common/CountdownTimer.vue